export enum Direction {
  Next = 'next',
  Prev = 'previous'
}

export enum EventItem {
  ArrowButton = 'arrow button',
  Carousel = 'carousel',
  Scrollbar = 'scrollbar'
}

export const SNAP_INTERVAL = 1;
export const SCROLL_INTERVAL = 4;
export const SCROLL_THRESHOLD = 0.999;
export const VISIBLE_SLIDE_COUNT = 4;
export const INITIAL_LOAD_COUNT = 8;
